<template>
  <div
    class="num-range d-inline-flex w-100"
  >
    <b-form-input
      v-model="from"
      type="number"
      :max="to"
      size="sm"
      :class="inputFromCls"
    />
    <div class="mx-0 mx-md-1 mx-lg-2">
      &nbsp;-&nbsp;
    </div>
    <b-form-input
      v-model="to"
      type="number"
      :min="from"
      size="sm"
      :class="inputToCls"
    />
  </div>
</template>

<script>
export default {
  name: 'NumRange',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    variant: {
      type: [String],
      default: ''
    }
  },
  data () {
    return {
      from: this.value?.from,
      to: this.value?.to
    }
  },
  computed: {
    inputFromCls () {
      if (this.variant && this.from) {
        return `border-${this.variant} text-${this.variant}`
      }
      return ''
    },
    inputToCls () {
      if (this.variant && this.to) {
        return `border-${this.variant} text-${this.variant}`
      }
      return ''
    }
  },
  watch: {
    value: {
      handler (n) {
        this.from = n?.from
        this.to = n?.to
      },
      deep: true
    },
    from (n) {
      this.$emit('input', this.getValue())
    },
    to (n) {
      this.$emit('input', this.getValue())
    }
  },
  methods: {
    getValue () {
      const value = {}
      if (this.from) {
        value.from = this.from
      }
      if (this.to) {
        value.to = this.to
      }
      return value
    }
  }
}
</script>
